import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
const instance = axios.create();
const nextAxios = setupCache(instance, { ttl: 1000 });

nextAxios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
nextAxios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn('401 Unauthorized: Session expired or invalid token. Reloading page...');
            window.location.reload();
            return new Promise(() => {});
        }
        return Promise.reject(error);
    },
);
export { nextAxios as axios };
window.axios = nextAxios;
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
